import { Component, OnInit, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ListInsurances, TypesOfDisabilitiesAdmin,StatusOptions  } from '../../candidate-disabilities/data.constants';
import { CandidateDisabilitiesService } from '../../../services/candidate-disabilities.service';
import { ConfirmationService, LazyLoadEvent, Message } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { calendarES } from '../../../../../theme/functions/calendarES';
import { constDatesFilter } from '../../../../../theme/functions/constDatesFilter.function';
import { getDiffDateDisabilty } from '../../../../../theme/functions/getDiffDate.function';
import { sortObj } from '../../../../../theme/functions/sortObj.function';
import { config } from '../../../../../../environments/config';
import { HasPermissionService } from '../../../../employee/service/has-permission/has-permission.service';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { atLeastOneFieldValidator } from '../../../../../theme/validators/atLeastOneFieldValidator';
@Component({
  selector: 'app-candidate-disabilities-admin',
  templateUrl: './candidate-disabilities-admin.component.html',
  styleUrls: ['./candidate-disabilities-admin.component.scss']
})
export class CandidateDisabilitiesAdminComponent implements OnInit {

  @ViewChild('gb') searchFilter;

  public apiUrl = config.API_ROOT;
  public modNew: boolean = false;
  public modView: boolean = false;
  public typesOfDisabilities = [...TypesOfDisabilitiesAdmin];
  public statusOptions = [...StatusOptions];
  public listInsurace: any[] = [];
  public disabilities: any[];
  public totalDisabilities: number;
  public candidateId: number;
  public page: number;
  public per_page: number;
  public filtersKanban: {key: string, value: string}[];
  public sort: string;
  public query: string;
  public filters: any[];
  public isLoading: boolean = true;
  public form_filter: FormGroup;
  public form_export: FormGroup;
  public es: any;
  public modExportReport: Boolean = false;
  public msgs: Message[] = [];

  constructor(private fb: FormBuilder,
              private candidateDisabilitiesService: CandidateDisabilitiesService,
              public translate: TranslateService,
              public hasPermissionService: HasPermissionService,
              public confirmationService: ConfirmationService,
            )
            {
              this.es = calendarES();
              let element =
                { value: '', label: 'Some', value_form :'' }
              ;
              this.typesOfDisabilities.unshift(element);
              this.statusOptions.unshift(element);
              this.typesOfDisabilities = this.translateLabels(this.typesOfDisabilities, 'label');
              this.statusOptions = this.translateLabels(this.statusOptions, 'label');
            }

  ngOnInit() {
    this.listInsurace = sortObj(ListInsurances,'asc');
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';

    this.filters = [];

    this.createFormFilter(null);
    this.createFormExport(null);
  }

  ngOnDestroy() {

  }

  createFormFilter (data:any=null){
    data = data||{
      list_disabilities_type_id_filter: '',
      insurance_id_filter: '',
      status_id_filter: '',
      candidate_id_filter: null,
      company_id_filter: null,
      created_at_date_min_filter: null,
      created_at_date_max_filter: null,
      start_date_min_filter: null,
      start_date_max_filter: null,
      end_date_min_filter: null,
      end_date_max_filter: null,
      _q_filter: null
    };

    this.form_filter = this.fb.group({
      list_disabilities_type_id_filter: data.list_disabilities_type_id_filter,
      insurance_id_filter: data.insurance_id_filter,
      status_id_filter: data.status_id_filter,
      candidate_id_filter: data.candidate_id_filter,
      company_id_filter: data.company_id_filter,
      status_filter: [ data.status_filter ],
      created_at_min: [ data.created_at_min],
      created_at_max: [ data.created_at_max],
      start_date_min: [ data.start_date_min],
      start_date_max: [ data.start_date_max],
      end_date_min: [ data.end_date_min],
      end_date_max: [ data.end_date_max],
      _q_filter: [ data._q_filter],
    }
    );
  }

  createFormExport(data: any = null) {
    // Asignar valores por defecto si 'data' es null
    data = data || {
      list_disabilities_type_id_filter: null,
      insurance_id_filter: null,
      status_id_filter: null,
      status_filter: null,
      candidate_id_filter: null,
      company_id_filter: null,
      created_at_min: null,
      created_at_max: null,
      start_date_min: null,
      start_date_max: null,
      end_date_min: null,
      end_date_max: null,
    };

    // Crear el formulario
    this.form_export = this.fb.group(
      {
        list_disabilities_type_id_filter: [data.list_disabilities_type_id_filter || null],
        insurance_id_filter: [data.insurance_id_filter || null],
        status_id_filter: [data.status_id_filter || null],
        status_filter: [data.status_filter || null],
        candidate_id_filter: [data.candidate_id_filter || null],
        company_id_filter: [data.company_id_filter || null],
        created_at_min: [data.created_at_min || null],
        created_at_max: [data.created_at_max || null],
        start_date_min: [data.start_date_min || null],
        start_date_max: [data.start_date_max || null],
        end_date_min: [data.end_date_min || null],
        end_date_max: [data.end_date_max || null],
      });
    this.form_export.setValidators(atLeastOneFieldValidator());
    this.form_export.updateValueAndValidity();
  }


  public loadCandidateDisabilitiesLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;

    if (event.sortOrder === -1)
      this.sort =  '-' + event.sortField;
    else
      this.sort =  event.sortField;

    if (event.globalFilter)
      this.query = event.globalFilter;
    else
      this.query = undefined;

    this.sort = '-id';

    this.getCandidateDisabilities();
  }

  public filter(values?) {
    this.page = 1;
    // this.first = 0;
    this.filters = [];

    Object.keys(values).forEach(key => {
      let value = values[key];

      if(value !== 'all' && value !== null && value !== '' && value !== undefined)
      {

        const newKey = key.replace("_filter", "");
        if (value instanceof Date)
        {
          if(newKey.endsWith('_min'))
            value = constDatesFilter(value,true,false);
          else
            value = constDatesFilter(value,false,false);
        }
        else
          value =  this.formatValue(value);
        this.filters.push({'key': newKey, 'value': value });
      }

    });

   this.getCandidateDisabilities();
  }

  public getCandidateDisabilities() {
    this.candidateDisabilitiesService.getDisability(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
      response => {
        this.disabilities = response.json().data;
        this.totalDisabilities = response.json().meta.total;
        this.isLoading = false; // Cambia a falso una vez que se cargan los datos
      },
      error => {
        // console.error('Error fetching disabilities:', error);
        this.isLoading = false; // Asegúrate de que también se establezca a falso en caso de error
      }
    );
  }


  public newDisability() {
    this.modNew = true;
    this.modView = false;
  }

  public savedNewDisability(res) {
    this.modNew = false;
    this.getCandidateDisabilities(); // Recargar incapacidades después de guardar
  }

  public cancelNewDisability() {
    this.modNew = false;
    this.modView = false;
  }

  public translateLabels(array: any[], labelKey: string) {
    return array.map(item => {
      this.translate.get(item[labelKey]).subscribe((translatedLabel: string) => {
        item[labelKey] = translatedLabel;
      });
      return item;
    });
  }

  public getDiffDateLoc(date_start, date_end) {
    return getDiffDateDisabilty(date_start,date_end);
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public formatValue = (value: any) => {
    if (value == null) return value;
    if (value instanceof Date) return formatDate(value);
    if (value.id) return value.id;
    if (value.code) return value.code;
    return value;
  };

  public showExportReport() {
    this.modExportReport = true;
  }
  public cancelExport() {
    this.modExportReport = false;
  }

  public exportReportExcel(values) {
    let token = localStorage.getItem('token');
    let url = this.apiUrl + '/disabilities/excel?' +
    'token=' + token + '&';

    Object.keys(values).forEach(key => {
      let value = values[key];

      // Candidato/empresa solo se envían si se seleccionó una opción del autocomplete (objeto con id)
      if ((key === 'candidate_id_filter' || key === 'company_id_filter') && !(value && value.id))
        return;

      if(value !== 'all' && value !== null && value !== '' && value !== undefined)
      {

        const newKey = key.replace("_filter", "");
        if (value instanceof Date)
        {
          if(newKey.endsWith('_min'))
            value = constDatesFilter(value,true,false);
          else
            value = constDatesFilter(value,false,false);
        }
        else
          value = this.formatValue(value);
        url += newKey + '=' + encodeURIComponent(value) + '&';
      }

    });

    window.open(url, '_blank');

    // this.modExportReport = false;
  }

  public deleteDialog(disability) {
    let message;
    this.translate.get('Do you want to delete?').subscribe((res: string) => {
        message = res;
    });
    let header;
    this.translate.get('Delete Confirmation').subscribe((res: string) => {
        header = res;
    });

    this.confirmationService.confirm({
        message: message,
        header: header,
        icon: 'fa fa-trash',
        accept: () => {
            this.delete(disability);
        }
    });
  }

  public delete(disability) {
      this.candidateDisabilitiesService.deleteDisability(disability).toPromise().then(
          response => {
              this.msgs = [];
              this.msgs.push( { severity: 'success', summary: 'Incapacidad Eliminada' } );
              this.getCandidateDisabilities();
          },
          error => {
              this.msgs = [];
              this.msgs.push( { severity: 'error', summary: 'error' } );
          }
      );
  }

  public MergeDocuments(idDisability: number) {
    window.open(this.apiUrl + '/disabilities-merge-documents/' + idDisability + '?token=' + localStorage.getItem('token'), '_blank');
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/disability/components/candidate-disabilities-admin/candidate-disabilities-admin/candidate-disabilities-admin.component.ts